import { render, staticRenderFns } from "./uploadRecord.vue?vue&type=template&id=f775aec2&scoped=true&"
import script from "./uploadRecord.vue?vue&type=script&lang=js&"
export * from "./uploadRecord.vue?vue&type=script&lang=js&"
import style0 from "./uploadRecord.vue?vue&type=style&index=0&id=f775aec2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f775aec2",
  null
  
)

export default component.exports